import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  Breadcrumbs,
  CardComponent,
  BasicTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CostValues,
  MemberValues,
  PEPM,
  PMPM,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import { DEEP_DIVE, RX_UTILIZATION } from '../../core-utils/routes';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import TabSelection from '../../_components/molecules/TabSelection';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { pageScrollDown } from '../SummaryPage';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
// import DrugSurgeChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/DrugSurgeChart';
// import DrugCategoriesChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/DrugCategoriesChart';
import utilizationRx from '../../core-utils/messages/utilizationRx';
import OTHER_PRESCRIPTION_MESSAGES from './textConstants';
// import {
//   IDrugCategories,
//   ILabel,
//   IValue,
//   SPECIALITY_DRUG_TYPE,
//   formatDrugCategoriesResponse,
//   formatRxDrugSurgeResponse,
// } from '../../core-utils/helper-utils/pharmacySpendHelper';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  commasForNumbers,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import componentConstants from '../../core-utils/messages/componentConstants';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import {
  formatTopDrugsData,
  topDrugsTableColumn,
} from '../UtilizationRx/utilizationRxConstants';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import { observer } from 'mobx-react';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

// interface IRxDrugSurgeChartData {
//   labels: ILabel[];
//   brandedCurrentYearValues: IValue[];
//   brandedPreviousYearValues: IValue[];
//   genericCurrentYearValues: IValue[];
//   genericPreviousYearValues: IValue[];
// }

const OtherPrescriptionPage = observer(() => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
  });

  const { classes } = useStyles();

  const employerGroupStore = useStores().employerGroupStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();
  const loginPageStore = useStores().loginPageStore;

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  //Text Constants :
  const messages = OTHER_PRESCRIPTION_MESSAGES;
  // const pageConstants = componentConstants.PAGES.PHARMACY_SPEND_PAGES;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  //OverView Cards Use States:

  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });

  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });

  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });

  const [pmpm] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });

  const [pepm] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [topDrugsTableData, setTopDrugsTableData] = useState<any>([]);
  const [
    isPreviousYearAvailable,
    setIsPreviousYearAvailable,
  ] = useState<boolean>(true);
  const [isTopDrugsTableLoading, setIsTopDrugsTableLoading] = useState<boolean>(
    false,
  );
  const [
    topDrugsTableCurrentPage,
    setTopDrugsTableCurrentPage,
  ] = useState<number>(1);
  const [
    topDrugsTableTotalPages,
    setTopDrugsTableTotalPages,
  ] = useState<number>(20);

  const [sortField, setSortField] = useState(messages.MAIN_SORT_COLUMN);
  const [sortOrder, setSortOrder] = useState(messages.MAIN_SORT_ORDER);
  const [columnId, setColumnId] = useState<string>();
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snacker bar variables and functions
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.PAGE_HEADINGS.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  //Use History:
  const navigate = useNavigate();
  const {
    totalResults,
    memberIds: cohortMembers,
    isInitializing,
  } = useCohortOnPageLoad({
    fetchTotalResults: () => getMedPharmaCohortMembers(),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleTopDrugsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setTopDrugsTableCurrentPage(value);
    getTopDrugsTableData();
  };

  const handleOnClick = (value: string, key: string) => {
    navigate(DEEP_DIVE, {
      state: {
        key: key,
        value: value,
      },
    });
  };

  //charts data
  // const [
  //   drugSurgeChartData,
  //   setDrugSurgeChartData,
  // ] = useState<IRxDrugSurgeChartData>({
  //   labels: [],
  //   brandedCurrentYearValues: [],
  //   brandedPreviousYearValues: [],
  //   genericCurrentYearValues: [],
  //   genericPreviousYearValues: [],
  // });

  // const [
  //   drugCategoriesOfCancerChartData,
  //   setDrugCategoriesOfCancerChartData,
  // ] = useState<IDrugCategories[]>([]);
  // const [
  //   drugCategoriesOfNonCancerChartData,
  //   setDrugCategoriesOfNonCancerChartData,
  // ] = useState<IDrugCategories[]>([]);

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(
    aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
    aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
    employerGroupStore,
    abortController.signal,
  );

  const getMedPharmaCohortMembers = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.getMedPharmaCohortMember;
    const requestBody = {
      ...payload,
      claim_type: 'rx',
      speciality_drug_type: 'Non-Speciality Drug',
    };

    const defaultResponse = {
      memberIdList: [],
      numberOfEmployees: 0,
      numberOfDependents: 0,
      totalCost: 0,
    };

    return await axios
      .post(url, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          return res?.data?.data;
        }
        return defaultResponse;
      })
      .catch(() => {
        return defaultResponse;
      });
  };

  const getSummary = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.pharmacySpend +
      properties.pharmacySummary;

    const requestBody = {
      ...payload,
      claim_type: 'rx',
      speciality_drug_type: 'Non-Speciality Drug',
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
    };

    const defaultResponse = {
      memberIdList: [],
      numberOfEmployees: 0,
      numberOfDependents: 0,
      totalCost: 0,
    };

    return await axios
      .post(url, requestBody, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          return res?.data?.data;
        }
        return defaultResponse;
      })
      .catch(() => {
        return defaultResponse;
      });
  };

  const getTopDrugsTableData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topDrugs;
    const body = {
      ...payload,
      claim_id_list: [],
      member_unique_id_list: [],
      medicationTypeList: ['Non-Speciality Drug'],
      pageNumber: topDrugsTableCurrentPage - 1,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    setIsTopDrugsTableLoading(true);
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setIsPreviousYearAvailable(res?.data?.data?.isPreviousYearAvailable);
          setTopDrugsTableData(
            formatTopDrugsData(
              res?.data?.data?.topDrugs,
              false,
              false,
              handleOnClick,
            ),
          );
          setTopDrugsTableTotalPages(
            Math.ceil(res?.data?.data?.totalCount / 10),
          );
          setIsTopDrugsTableLoading(false);
        }
      })
      .catch((error) => {
        setIsTopDrugsTableLoading(false);
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  // const getDrugSurgeChartData = async () => {
  //   const url =
  //     properties.aiqBaseUrl +
  //     properties.pharmacySpend +
  //     properties.pharmacySpendRx +
  //     properties.drugSurge;

  //   const requestBody = {
  //     ...payload,
  //     member_id_list: [],
  //     speciality_drug_type: SPECIALITY_DRUG_TYPE.OTHER_PRESCRIPTION_DRUG,
  //   };

  //   const defaultResponse = {
  //     labels: [],
  //     brandedCurrentYearValues: [],
  //     brandedPreviousYearValues: [],
  //     genericCurrentYearValues: [],
  //     genericPreviousYearValues: [],
  //   };

  //   return await axios
  //     .post(url, requestBody, { signal: abortController.signal })
  //     .then((res: any) => {
  //       if (res?.status === 200) {
  //         return formatRxDrugSurgeResponse(res?.data?.data);
  //       }
  //       return defaultResponse;
  //     })
  //     .catch(() => {
  //       return defaultResponse;
  //     });
  // };

  // const getDrugCategoriesChartData = async (
  //   categoryType: 'Cancer' | 'Non-cancer',
  // ) => {
  //   const url =
  //     properties.aiqBaseUrl +
  //     properties.pharmacySpend +
  //     properties.pharmacySpendRx +
  //     properties.drugCategories;

  //   const requestBody = {
  //     ...payload,
  //     member_id_list: [],
  //     speciality_drug_type: SPECIALITY_DRUG_TYPE.OTHER_PRESCRIPTION_DRUG,
  //     drug_category_type: categoryType,
  //   };

  //   return await axios
  //     .post(url, requestBody, { signal: abortController.signal })
  //     .then((res: any) => {
  //       if (res?.status === 200) {
  //         return formatDrugCategoriesResponse(res?.data?.data);
  //       }
  //       return [];
  //     })
  //     .catch(() => {
  //       return [];
  //     });
  // };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // 1️⃣ Get summary
      const summaryData = await getSummary();

      // 2️⃣ Fetch ALL drugs (showAll = true)
      const drugsUrl =
        properties.aiqBaseUrl +
        properties.utilizationRxBaseUrl +
        properties.topDrugs;

      const drugsBody = {
        ...payload,
        claim_id_list: [],
        member_unique_id_list: [],
        medicationTypeList: ['Non-Speciality Drug'],
        pageNumber: 0,
        sortField: 'totalCost',
        sortOrder: -1,
        includeAll: true,
      };

      const drugsRes = await axios.post(drugsUrl, drugsBody);

      const allDrugs = drugsRes?.data?.data?.topDrugs?.slice(0, 50) ?? [];

      // 3️⃣ Prepare AI context
      const apiResponses = {
        title_1: {
          numberOfEmployees: summaryData?.numberOfEmployees,
          numberOfDependents: summaryData?.numberOfDependents,
          totalMembers:
            (summaryData?.numberOfEmployees || 0) +
            (summaryData?.numberOfDependents || 0),
          totalCost: summaryData?.totalCost,
        },

        title_2: allDrugs?.map((item: any) => ({
          drugName: item?.medication,
          totalCost: item?.totalCost,
          memberCount: item?.claimantsCount,
          claimCount: item?.claimsCount,
          drugType: item?.drugType,
          atcLevel: item?.atcLevel,
        })),
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.NON_SPECIALITY_DRUGS,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(
        error?.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
        'error',
        6000,
      );
    } finally {
      setAiLoading(false);
    }
  };
  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        // getDrugSurgeChartData(),
        // getDrugCategoriesChartData('Cancer'),
        // getDrugCategoriesChartData('Non-cancer'),
        getSummary(),
        getTotalEligible(),
        getTopDrugsTableData(),
      ]).then((responses) => {
        // const {
        //   labels,
        //   brandedCurrentYearValues,
        //   brandedPreviousYearValues,
        //   genericCurrentYearValues,
        //   genericPreviousYearValues,
        // } = responses[0];
        // setDrugSurgeChartData({
        //   labels,
        //   brandedCurrentYearValues,
        //   brandedPreviousYearValues,
        //   genericCurrentYearValues,
        //   genericPreviousYearValues,
        // });
        // setDrugCategoriesOfCancerChartData(responses[1]);
        // setDrugCategoriesOfNonCancerChartData(responses[2]);
        setCostValues({
          total: '$' + commasForNumbers(responses[0].totalCost, 2),
          medical: '',
          rx: '',
        });
        setTotalCost({
          totalCost: '$' + numFormatterWithSuffix(responses[0].totalCost, 2),
          totalMedical: '',
          totalRx: '',
        });
        setMemberValues({
          members: commasForNumbers(
            String(
              responses[0].numberOfEmployees + responses[0].numberOfDependents,
            ),
          ),
          dependents: commasForNumbers(String(responses[0].numberOfDependents)),
          employees: commasForNumbers(String(responses[0].numberOfEmployees)),
        });
        setLoading(false);
      }));
    setLoading(false);
  };

  //useEffects:

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  // Page Components:
  const MedPharmaComponents = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
    });

    const { classes } = useStyles();
    return (
      <>
        <Grid container className={classes.root}>
          <Grid style={{ display: 'flex', marginBottom: '29px' }}>
            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="member"
                cohortMemberValues={memberValues}
                totalMemberValues={{
                  dependents: overAllEnrolled.dependents,
                  employees: overAllEnrolled.employees,
                  members: overAllEnrolled.totalCount,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.MEMBERS}
                    value={getCohortValue(
                      memberValues.members,
                      overAllEnrolled.totalCount,
                    )}
                    rootStyles={{
                      width: '176px',
                      height: '100px',
                    }}
                  />
                }
              />
            </Grid>

            <Grid style={{ marginRight: '24px' }}>
              <OverviewCardTooltipContent
                type="cost"
                hideDetailedInfo={true}
                cohortCostValues={costValues}
                totalCostValues={{
                  medical: overallTotalCost.totalMedical,
                  rx: overallTotalCost.totalRx,
                  total: overallTotalCost.totalCost,
                }}
                overviewCard={
                  <OverviewCard
                    title={messages.OVERVIEW_CARDS.COST}
                    value={getCohortValue(
                      (totalCost?.totalCost).toString(),
                      overallTotalCost.totalCost,
                    )}
                    rootStyles={{
                      width: '216px',
                    }}
                  />
                }
              />
            </Grid>

            {/* temporary disabling pmpm and pepm cards */}
            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PMPM}
                value={pmpm?.pmpm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>

            <Grid style={{ marginRight: '24px', display: 'none' }}>
              <OverviewCard
                title={messages.OVERVIEW_CARDS.PEPM}
                value={pepm?.pepm}
                rootStyles={{
                  width: '176px',
                  height: '100px',
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid style={{ marginTop: '28px' }}>
          <CardComponent
            title={messages.TOP_DRUGS_TABLE.TITLE}
            subTitle={messages.TOP_DRUGS_TABLE.SUBTITLE}
            height="auto"
            width="1177px"
            body={
              isTopDrugsTableLoading ? (
                <Box
                  style={{
                    display: 'flex',
                    height: '450px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CircularLoader />
                </Box>
              ) : (
                <>
                  <Grid style={{ margin: '7px 0px 0px 6px' }}>
                    <BasicTable
                      columns={topDrugsTableColumn}
                      cellHeight="56px"
                      cellPadding="12px 9px 12px 14px"
                      rowsData={topDrugsTableData}
                      displayType="row"
                      tableHeight="auto"
                      columnId={columnId}
                      handleHeaderMouseEnter={(column: any) =>
                        handleHeaderMouseEnter(column, setColumnId)
                      }
                      handleHeaderMouseLeave={() =>
                        handleHeaderMouseLeave(setColumnId)
                      }
                      showOnHoverHeader={true}
                      handleMenuItem={handleSort}
                      width="1100px"
                      hideColumnIndex={!isPreviousYearAvailable ? 4 : -1}
                      noDataText={messages.NO_DATA_DRUGS}
                    />
                  </Grid>
                  <Grid
                    container
                    style={{
                      marginTop: '16px',
                    }}
                    sx={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Pagination
                      page={topDrugsTableCurrentPage}
                      count={topDrugsTableTotalPages}
                      onChange={handleTopDrugsTablePageChange}
                      size="small"
                      color="primary"
                    />
                  </Grid>
                </>
              )
            }
          />
        </Grid>
        {/* <Box style={{ marginBottom: '28px' }}>
          <DrugSurgeChart
            isMedPharma={false}
            xAxisLabel={drugSurgeChartData.labels}
            brandedCurrentYearData={drugSurgeChartData.brandedCurrentYearValues}
            genericCurrentYearData={drugSurgeChartData.genericCurrentYearValues}
            brandedPreviousYearData={
              drugSurgeChartData.brandedPreviousYearValues
            }
            genericPreviousYearData={
              drugSurgeChartData.genericPreviousYearValues
            }
            cardHeight={'443px'}
          />
        </Box>
        <Box style={{ display: 'flex', marginBottom: '28px' }}>
          <Box style={{ marginRight: '24px' }}>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfCancerChartData}
            />
          </Box>
          <Box>
            <DrugCategoriesChart
              title={pageConstants.DRUG_CATEGORIES_NON_CANCER_TITLE}
              subTitle={pageConstants.DRUG_CATEGORIES_NON_CANCER_SUBTITLE}
              cardHeight={'341px'}
              data={drugCategoriesOfNonCancerChartData}
            />
          </Box>
        </Box> */}
      </>
    );
  };

  return (
    <>
      {isPlanDatesLoading || loading || isInitializing ? (
        <Loader />
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid style={{ marginBottom: '20px' }}>
              <Breadcrumbs
                itemList={[
                  [
                    'text',
                    utilizationRx.titleAndSubtitle.title,
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => {
                      navigate(RX_UTILIZATION);
                    },
                  ],
                  [
                    'text',
                    messages.PAGE_HEADINGS.TITLE,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ],
                ]}
              />
            </Grid>

            <Grid
              style={{
                marginBottom: '36px',
                width: '1182px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={messages.PAGE_HEADINGS.TITLE}
                subTitle={messages.PAGE_HEADINGS.SUB_TITLE}
                showDownloadButton={true}
                downloadButtonAction={() => {
                  downloadPdf(
                    'individualPharmacyUtilizationReport',
                    {
                      startDate:
                        aggregationParameter === 'paid'
                          ? paidStartDate
                          : incurredStartDate,
                      endDate:
                        aggregationParameter === 'paid'
                          ? paidEndDate
                          : incurredEndDate,
                      eg_nid:
                        employerGroupStore?.employerGroupResponseData?.eg_nid,
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      category: 'otherPrescription',
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showAskAi={true}
                askAiAction={handleAskAi}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                  cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-3px',
                  left: '216px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationLoading}
              />
              <CohortFilterBar />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && (
                <>
                  <MedPharmaComponents />
                </>
              )}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                  isInternalPage={false}
                />
              )}
            </Grid>
            <div id="scroll-top-element" />
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={cohortMembers}
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
    </>
  );
});

export default OtherPrescriptionPage;
